import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=523cfa2a"
import script from "./ToolbarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports